// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1urOz","title":"Header_title__1QV-5","actions":"Header_actions__jLG-A"};